import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRowingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M29.417 0A2.583 2.583 0 0132 2.583v.788c0 .552-.177 1.09-.504 1.533l-2.92 3.961A5.25 5.25 0 0124.35 11h-4.732l-2.032 2.603 4.548 5.825 1.026-.855 1.6 1.92-1.087.907 6.882 8.816-1.97 1.539L21.75 23l-.911.76-1.6-1.921.972-.81L16 15.634l-4.212 5.396.972.81-1.6 1.92-.911-.759-6.834 8.754-1.97-1.539L8.326 21.4l-1.087-.907 1.6-1.92 1.026.855 4.548-5.825L12.382 11H7.65a5.25 5.25 0 01-4.225-2.135L.504 4.905A2.583 2.583 0 010 3.37v-.788A2.583 2.583 0 012.583 0h3.411c.82 0 1.59.389 2.077 1.047l5.161 6.98L16 11.571l2.768-3.546 5.16-6.979A2.584 2.584 0 0126.006 0zm.083 2.583a.083.083 0 00-.083-.083h-3.411a.083.083 0 00-.067.034L21.527 8.5h2.823a2.75 2.75 0 002.213-1.118l2.92-3.961a.084.084 0 00.017-.05zm-27 0v.788c0 .018.006.035.016.05l2.92 3.96A2.75 2.75 0 007.65 8.5h2.823L6.061 2.534a.083.083 0 00-.067-.034h-3.41a.083.083 0 00-.084.083z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRowingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRowingNormalMedium;
